<template>
  <div class="" style="padding:.2rem 0 8rem 0">
 

    <van-dialog
            v-model="dialogShow"  
    > 

      <div class="order-success" v-if="row.erweiimg.length>0">
        <img :src="row.erweiimg[0].url" />
        <p  >请扫码联系工作人员</p>
      </div>
      <div v-else> 
        <p  >请联系工作人员</p>
      </div>
    </van-dialog>
 

    <van-divider @click="edit(1)">场次信息 <van-icon name="edit" /></van-divider>
    <van-cell-group>

      <van-cell
          input-align="right"
          title="单位"
          :value="row.danwei"
      />
      <van-cell
          input-align="right"
          title="场次"
          :value="row.station_name"
      />
      <van-cell
          input-align="right"
          title="时间"
          :value="row.station.startdate+'至'+row.station.enddate"
      />
      <van-cell
          input-align="right"
          title="地点"
          :value="row.station.province+'  '+row.station.city+' '+row.station.county"
      />
    </van-cell-group>
    <van-divider @click="edit(2)">人员信息 <van-icon name="edit" /></van-divider>
    <van-cell-group :key="memberindex" v-for="(membervalue,memberindex) in row.member_list ">
      <van-cell
          input-align="right"
          title="省市区"
          :value="row.province+'  '+row.city+' '+row.county+' '+row.address"
      />
      <van-cell
          input-align="right"
          title="姓名"
          :value="membervalue.name"
      />
      <van-cell
          input-align="right"
          title="身份证号"
          :value="membervalue.num"
      />
      <van-cell
          input-align="right"
          title="手机号"
          :value="membervalue.phone"
      />
      <van-cell
          input-align="right"
          title="微信"
          :value="membervalue.weixin"
      />
      <van-cell
          input-align="right"
          title="性别"
          :value="membervalue.sex"
      />
      <van-cell
          input-align="right"
            v-if="membervalue.need_jie==1"
          title="接站时间"
          :value="membervalue.jie_date"
      />
      <van-cell
          input-align="right"
            v-if="membervalue.need_jie==1"
          title="接站车次/航班号"
          :value="membervalue.jie_code"
      />
      <van-cell
          input-align="right"
            v-if="membervalue.need_song==1"
          title="送站时间"
          :value="membervalue.song_date"
      />
      <van-cell
          input-align="right"
            v-if="membervalue.need_song==1"
          title="送站车次/航班号"
          :value="membervalue.song_code"
      />


      <van-cell
          input-align="right"
            v-if="membervalue.service_name"
          title="服务套餐"
          :value="membervalue.service_name"
      />


      <van-cell
       v-for="(field,fileindex) in membervalue.jsondata" 
                 :key="fileindex"
          input-align="right"  
          :title="fileindex"
          v-show="typeof field == 'string'"
          :value="field"
      />
    </van-cell-group> 



    <van-divider @click="edit(5)">发票信息 <van-icon name="edit" /></van-divider>
    <van-cell-group>

      <van-cell
          input-align="right"
          title="发票抬头"
          :value="row.fapiao_taitou"
      />
      <van-cell
          input-align="right"
          title="税号"
          :value="row.fapiao_shuihao"
      />
      <van-cell
          input-align="right"
          title="地址"
          :value="row.fapiao_address"
      />
      <van-cell
          input-align="right"
          title="电话"
          :value="row.fapiao_tel"
      />
      <van-cell
          input-align="right"
          title="开户行及账号"
          :value="row.fapiao_account"
      />
      <van-cell
          input-align="right"
          title="发票备注"
          :value="row.fapiao_beizhu"
      />
      <van-cell
          input-align="right"
          title="接收邮箱"
          :value="row.fapiao_email"
      />
      <van-cell
          input-align="right"
          title="接收手机"
          :value="row.fapiao_phone"
      />
    </van-cell-group>
 

        <div style="padding: 20px;">
            <van-button type="primary"  size="large" v-if="row.confirm_1==2" @click.stop="save">信息无误 我已确认</van-button>
            <van-button   type="primary" size="large"  plain v-else >信息已确认</van-button>

            <!-- <van-button size="large" plain style="margin: 10px 0" @click.stop="dialogShow=true">信息需要修改</van-button> -->


            <van-button size="large" plain style="margin: 10px 0" @click.stop="goIndex">返回首页</van-button>
        </div>
          
    </div>  
   
  

  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}

.cert-li {
  margin:0 .3rem;
  text-align: center;
}

.cert-li img {
  width: 100%;
  border-radius: 5px;
}

.order-success {
  text-align: center;
  margin: 20px 0;
}

.order-success .icon {
  background: url(../../../assets/images/icon-order-done.png);
  background-size: 100%;
  width: 75px;
  height: 75px;
  margin: 20px auto 20px auto;

}

.order-success .title {
  font-size: 18px;
  font-weight: bold;
  color: #000;
  text-align: center;
}

.order-success .desc {
  padding: 10px;
  text-align: left;
}

.order-success .desc p {
  line-height: 26px;
  font-size: 14px;
  color: #333;
  text-align: left;
}

.order-success img {
  width: 90%;
  /*height: 120px;*/
  margin: 10px auto;
}

.order-success p {
  font-size: 12px;
  color: #999;
}

.sai-shuo-li {
  background: #f3f3f3;
  border-radius: 10px;
  margin: 20px 10px;
  padding: 10px;
}

.sai-shuo-li img {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  float: left;
  margin-right: 10px;
}

.sai-shuo-li .c {
  width: calc(100% - 80px);
  border-right: 1px solid #00000008;
}

.sai-shuo-li .c .title {
  font-size: 14px;
  color: #000;
}

.sai-shuo-li .c .desc {
  font-size: 12px;
  color: #999;
}

.sai-shuo-li .fr {
  width: 70px;
  float: right;
}

.sai-shuo-li .btn {
  width: 60px;
  height: 26px;
  line-height: 26px;
  font-size: 12px;
  text-align: center;
  background: linear-gradient(90deg, rgba(254, 200, 53, 1) 0%, rgba(255, 173, 25, 1) 100%);
  border-radius: 6px;
  color: #fff;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import FileUploader from '@/components/picker/FileUploader.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  Dialog,
  RadioGroup,
  Radio,
  ActionSheet,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';
import CaipanPicker from '@/components/picker/CaipanPicker.vue';
import FamliyPicker from '@/components/picker/FamliyPicker.vue';


import jquery from 'jquery';

jquery.fn.longPress = function (fn) {
  let timeout = 0;
  const $this = this;
  console.log('jquery.fn.longPress')
  for (let i = 0; i < $this.length; i++) {
    $this[i].addEventListener('touchstart', () => {
      timeout = setTimeout(fn, 800); // 长按时间超过800ms，则执行传入的方法
    }, false);
    $this[i].addEventListener('touchend', () => {
      clearTimeout(timeout); // 长按时间少于800ms，不会执行传入的方法
    }, false);
  }
};

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'SaiApplyFormStep2',
  components: {
    [Field.name]: Field,
    PicUploader,
    [Dialog.name]: Dialog,
    FileUploader,
  },
  data: function () {
    return {
      ltShow: false,
      dialogShow:false,
      ltImgSrc: '',
      ltImgName: '',
      ltActions: [{name: '保存图片'}],
      validator,
      saveLoading: false,
      fileUrlShow: false,
      showFamliyPicker: false,
      showSubjectPicker: false,
      showJiaolianPicker: false,
      showRoomTypePicker: false,
      showMemberPicker: false,
      formData: {
        id: 0
      },
      row: {
        erweiimg: [],
        station_name:'',
        order:{},
        wechat_erweiimg: [],
        station: {
          zips:[],
          pay_qrcode:[]
        },
        member: {},
      },
      isApp: window.isApp()
    }
  },
  filters: {},
  mounted() {
    document.title = '报名成功';
    let that = this;
    that.areaList = area;
    that.formData.id = this.$route.query.id;
    if (that.formData.id) {
      this.fetch();
    }
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
      goIndex:function () {
          this.$router.push({
              'name' :'HuiyiConfirmManage',
              'query':{}
          })
      },
      edit(type){
        if(type==1){
          this.$router.push({
              'name' :'HuiyiApplyFormStepC1',
              'query':{id:this.row.id}
          })
        }else if(type==2){
          this.$router.push({
              'name' :'HuiyiApplyFormStepC2',
              'query':{id:this.row.id}
          })
        }else if(type==5){
          this.$router.push({
              'name' :'HuiyiApplyFormStepC5',
              'query':{id:this.row.id}
          })
        }
      },
      save:function () {
          let that = this;
          Dialog.confirm({
              title: '确认',
              message: '您确定信息准确无误吗?提交后不得修改!'
          }).then(() => {
              // on confirm
              that.$api.post('/api/huiyi/confirmaction', this.row, r => {
                  // that.$router.push({'name':'saiConfirm','query':{'id':that.pageData.id}});
              },r=>{
                  that.$toast.fail(r.msg);
              });
          }).catch(() => {
              // on cancel
          });


      },
    onLtSelect(item) {
      let that = this;
      switch (item.name) {
        case '保存图片':
          let name = that.ltImgSrc.split('?')[0].split('/').pop();
          console.log(that.ltImgSrc, name);
          appEvent({
            name: 'downloadPic',
            query: {
              'filename': name,
              'url': that.ltImgSrc
            }
          });
          break;
      }
    },
    goList() {
      rbLink({name: 'HuiyiApplyList', query: {}}, 'repalce');
    },
    goFiles(type) {
      rbLink({name: 'HuiyiFilesList', query: {station_id: this.row.station.id, type: type}});
    },
    toMyClub(){
      rbLink({name: 'MyClub'});
    },
    goCourse() {
      if(this.row.station.course_cate_id){
        // rbLink({name: 'CourseList', query: {cate_id: this.row.station.course_cate_id}});
        appEvent({
          name: "downloadFile",
          query: { url: 'https://h5.ccachina.net/cca-h5/dist/course-list?show=1&cate_id='+this.row.station.course_cate_id },
        });
      }else{
        rbLink({name: 'CourseDetail', query: {id: this.row.station.course_id}});
      }
    },
    downloadZips(){
        appEvent({
          name: "downloadFile",
          query: { url: this.row.station.zips[0].url },
        });
    },
    onQuestion() {
      console.log('onQuestion')
    },

    appDownload(name, url){
      let that = this;
      console.log('downloadPic');
      appEvent({
        name: 'downloadPic',
        query: {
          filename: name+'.jpg',
          url:url,
        }
      });
    },

    beizhu(){
        rbLink({
            'name' : 'Tpage1',
            'query':{
                id: this.row.id
            }
        } )
    },
    onCopy(e) {
        Toast.success('复制成功');
    },
    onError(e) {
        console.log('复制失败！');
    },
    fetch() {
      let that = this;
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0
      });
      that.$api.post('/api/huiyi/successdetail', {
        id: that.formData.id
      }, (res) => {
        that.row = res.data;

        Toast.clear()
//                    if(window.isApp()){
        setTimeout(() => {
          jquery('img').each(function () {
            jquery(this).longPress(() => {
              console.log('longPress', jquery(this).attr('src'));
              that.ltImgSrc = jquery(this).attr('src')
              that.ltImgName = jquery(this).attr('title')
              that.ltShow = true;
            });
          })
        }, 500);
        return false;
//                    }


      }, (res) => {
        Toast.fail(res.msg);
      })
    }

  }
}
</script>



// WEBPACK FOOTER //
// HuiyiConfirmDetail.vue?9107812e